<template>
  <section class="form-list">
    <v-table
      :count="count"
      :list="list"
      :is-loading="isLoading"
      :push-list="RouteConfig.courseScheduleList.push"
      :query-list="queryList"
      :is-show-store-select="isAdministrator"
      :is-store-select-clearable="true"
      :is-hide-filter="!isAdministrator"
      :is-not-top-list="true"
    >
      <el-table-column label="ID" prop="id" width="100px"/>
      <v-column-time/>
      <v-column-time value="修改时间" field="update_time" sortable=""/>
      <el-table-column label="课表名称" prop="schedule_name"/>
      <el-table-column label="所属门店">
        <template v-slot="{ row }">
          <span class="user-select">{{ row.store_name }}</span>
        </template>
      </el-table-column>
      <v-column-avatar label="添加者"/>

      <el-table-column label="开始日期">
        <template v-slot="{ row }">
          {{ row.start_date | timeToYmd }}
        </template>
      </el-table-column>
      <el-table-column label="结束日期">
        <template v-slot="{ row }">
          {{ row.end_date | timeToYmd }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300px">
        <template v-slot="{ row }">

          <v-list-button icon="copy" name="复制" :to="RouteConfig.courseScheduleAdd.to('', { id: row.id })"/>

          <v-list-button :to="RouteConfig.courseScheduleEdit.to(row.id)"/>

          <v-popover>
            <v-popover-item icon="generate-image" name="生成图片" @click="getImage(row)"/>
            <v-popover-item
              v-if="isAdministrator"
              icon="sync-course"
              name="生成课程"
              @click="handleGenerateCourse(row)"
              :is-loading="isGenerating[row.id]"
            />
            <v-popover-item
              v-else
              icon="sync-course"
              name="更新课程"
              @click="handleGenerateNextWeekCourses(row.id)"
              :is-loading="isGenerating[row.id]"
              message="系统将根据此课表生成未来 7 天的课程（包含今天），若课表有效期不包含未来 7 天，则不会执行；若课表对应的某课程已生成，则不会重复生成。确定要继续操作吗？"
            />
            <v-popover-item
              icon="bin"
              name="删除课表"
              @click="handleDelete(row)"
              :is-loading="isDeleting[row.id]"
              message="系统将不再根据该课表自动生成课程，已生成的课程需要手动删除，确定要删除此课表吗？"
            />
          </v-popover>
        </template>
      </el-table-column>

      <template slot="mobile-list">
        <section class="list">
          <template v-if="list.length">
            <div
              v-for="(v, k) in list"
              :key="`card-list-${k}-${v.id}`"
              class="list-item primary-background-light"
            >
              <div class="list-item-detail">
                <span>添加者</span>

                <v-avatar-nickname
                  :value="v.avatar"
                  :nickname="v.nickname"
                  :nickname-overflow="true"
                  :avatar-size="50"
                  width="30vw"
                />
              </div>

              <div class="list-item-detail">
                <span>课表 ID</span>
                <span>{{ v.id }}</span>
              </div>

              <div class="list-item-detail">
                <span>添加时间</span>
                <span>{{ v.add_time | timeToYmdHi }}</span>
              </div>
              <div class="list-item-detail">
                <span>修改时间</span>
                <span>{{ v.update_time | timeToYmdHi }}</span>
              </div>
              <div class="list-item-detail">
                <span>课表名称</span>
                <span>{{ v.schedule_name || '' }}</span>
              </div>
              <div class="list-item-detail">
                <span>所属门店</span>
                <span>{{ v.store_name || '' }}</span>
              </div>
              <div class="list-item-detail">
                <span>开始日期</span>
                <span>{{ v.start_date | timeToYmd }}</span>
              </div>
              <div class="list-item-detail">
                <span>结束日期</span>
                <span>{{ v.end_date | timeToYmd }}</span>
              </div>
              <div class="list-item-button">
                <v-list-button icon="copy" name="复制" :to="RouteConfig.courseScheduleAdd.to('', { id: v.id })"/>

                <v-list-button :to="RouteConfig.courseScheduleEdit.to(v.id)"/>

                <v-popover>
                  <v-popover-item icon="generate-image" name="生成图片" @click="getImage(v)"/>
                  <v-popover-item
                    v-if="isAdministrator"
                    icon="sync-course"
                    name="生成课程"
                    @click="handleGenerateCourse(v)"
                    :is-loading="isGenerating[v.id]"
                  />
                  <v-popover-item
                    v-else
                    icon="sync-course"
                    name="更新课程"
                    @click="handleGenerateNextWeekCourses(v.id)"
                    :is-loading="isGenerating[v.id]"
                    message="系统将根据此课表生成未来 7 天的课程（包含今天），若课表有效期不包含未来 7 天，则不会执行；若课表对应的某课程已生成，则不会重复生成。确定要继续操作吗？"
                  />
                  <v-popover-item
                    icon="bin"
                    name="删除课表"
                    @click="handleDelete(v)"
                    :is-loading="isDeleting[v.id]"
                    message="系统将不再根据该课表自动生成课程，已生成的课程需要手动删除，确定要删除此课表吗？"
                  />
                </v-popover>
              </div>
            </div>
          </template>

          <v-empty :is-loading="isLoading" :length="list.length"/>
        </section>
      </template>
    </v-table>
    <el-dialog
      title="指定日期生成课程"
      :visible.sync="generateCourseDialog.isShow"
      :width="isMobile ? '90vw' : '30vw'"
    >
      <el-form
        ref="form"
        label-position="right"
        label-width="80px"
        :rules="rules"
        :model="generateCourseDialog"
      >
        <el-form-item label="日期范围" prop="dates">
          <v-date-picker-schedule v-model="generateCourseDialog.dates"/>
        </el-form-item>

        <div>
          <el-button @click="generateCourseDialog.isShow = false">返回</el-button>

          <el-button
            slot="reference"
            type="primary"
            @click="handleGenerate"
            :loading="isGenerating[generateCourseDialog.id]"
          >
            立即生成
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import Fetch from '@/utils/fetch';
import { mapGetters } from 'vuex';
import { index, destroy, generateCourseByCourseScheduleId, generateNextWeekCourses, scheduleCoverApi } from '@/api/course-schedule';
import { getLegalQueryList } from '@/utils/formats';
import { toSecond } from "@/filters";

export default {
  name: RouteConfig.courseScheduleList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    isGenerating: {},
    queryList: {
      page: 1,
      size: 8,
      store_id: '',
      keyword: '',
      is_asc: 0,
    },
    count: 0,
    list: [],
    generateCourseDialog: {
      dates: [],
      isShow: false,
      id: 0,
    },
    rules: {
      dates: [{ required: true, message: '请选择日期范围',  trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.courseScheduleList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleGenerateCourse({ id }) {
      Object.assign(this.generateCourseDialog, {
        isShow: true,
        id,
      });
    },
    async load(route = this.$route) {
      getLegalQueryList(this.queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    async handleDelete({ id, update_time }) {
      if (this.isDeleting[id]) return;
      if (!id) return this.$message.error('缺少课表标识信息，无法进行删除！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.error('缺少课表信息，无法进行删除！');

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
    async handleGenerate() {
      const { id } = this.generateCourseDialog;
      if (this.isGenerating[id]) return;
      if (!id) return this.$message.error('缺少课表 id，无法生成！');

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.$set(this.isGenerating, id, true);
        const { isError } = await generateCourseByCourseScheduleId({
          id,
          start_date: toSecond(this.generateCourseDialog.dates[0]),
          end_date: toSecond(this.generateCourseDialog.dates[1]),
        });
        if (isError) return this.$set(this.isGenerating, id, false);

        this.generateCourseDialog.isShow = false;
        this.$message.success('已根据课表生成完毕，请前往课程列表查看！');
        setTimeout(() => this.$set(this.isGenerating, id, false), 1000);
      });
    },
    async handleGenerateNextWeekCourses(id) {
      if (this.isGenerating[id]) return;
      if (!id) return this.$message.error('缺少课表 id，无法生成！');

      this.$set(this.isGenerating, id, true);
      const { isError } = await generateNextWeekCourses({ id });
      if (isError) return this.$set(this.isGenerating, id, false);

      this.$message.success('已根据课表生成完毕，请前往课程列表查看！');
      setTimeout(() => this.$set(this.isGenerating, id, false), 1000);
    },
    async getImage({ id }) {
      open( `${Fetch.host}/${scheduleCoverApi}/${id}`);
    },
  },
};
</script>
